import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import General from './components/General'
import Notifications from './components/Notifications'
import Features from './components/Features'
import Security from './components/Security'
import Tabs from 'components/TabsRoutes'
import { Switch, Route } from 'react-router-dom'
import useCurrentUser from 'hooks/useCurrentUser'
import messages from './messages'

const UserSettingsPage = () => {
  const currentUser = useCurrentUser()
  const [user, setUser] = useState(currentUser)
  const [notifications, setNotifications] = useState([])
  const { formatMessage } = useIntl()

  useEffect(() => setUser(currentUser), [currentUser])

  useEffect(() => {
    fetch(`/rest/v2/user/me/notifications`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => setNotifications(data))
      .catch((err) => window.alert(err))
  }, [])

  const onNotificationChange = (id, enabled) => {
    const nextNotifications = notifications.map((n) => {
      if (n.id === id) {
        n.enabled = enabled
      }

      return n
    })

    setNotifications(nextNotifications)

    fetch(`/rest/v2/user/me/notifications`, {
      method: 'PUT',
      credentials: 'same-origin',
      body: JSON.stringify(nextNotifications)
    })
      .then((response) => response.json())
      .then(({ data }) => setNotifications(data))
      .catch((err) => window.alert(err))
  }

  const onUserChange = (nextUser) => {
    const prevUser = { ...user }

    setUser({ ...nextUser, image: user.image })

    let promise

    if (prevUser.image !== nextUser.image && !!nextUser.image) {
      promise = fetch(`/rest/v2/user/me/avatar`, {
        method: 'POST',
        credentials: 'same-origin',
        body: nextUser.image,
      })
    } else {
      promise = fetch(`/rest/v2/user/me`, {
        method: 'PUT',
        credentials: 'same-origin',
        body: JSON.stringify(nextUser)
      })
    }

    promise.then((response) => response.json())
      .then(({ success, data, errors }) => {
        if (!success) {
          setUser(prevUser)
          window.alert(errors.join('. '))
        } else {
          setUser({ ...data, image: data.image ? `${data.image}?time=${+Date.now()}` : null })
        }
      })
      .catch((err) => window.alert(err))
  }

  return (
    <main className="flex-1 overflow-y-auto focus:outline-none" tabIndex="0">
      <div className="relative max-w-4xl mx-auto md:px-8 xl:px-0">
        <div className="pt-10 pb-16">
          <div className="px-4 sm:px-6 md:px-0">
            <div className="py-6">
              <Tabs tabs={[
                {
                  message: formatMessage(messages.general),
                  to: '/settings',
                  route: {
                    path: '/settings',
                    exact: true,
                    render: () => (
                      <General {...user} onChange={onUserChange} />
                    ),
                  }
                },
                {
                  message: formatMessage(messages.notifications),
                  to: '/settings/notifications',
                  route: {
                    path: '/settings/notifications',
                    render: () => (
                      <Notifications
                        notifications={notifications}
                        onNotificationChange={onNotificationChange}
                        user={user}
                        onUserChange={onUserChange}
                      />
                    ),
                  }
                },
                {
                  message: formatMessage(messages.security),
                  to: '/settings/security',
                  route: {
                    path: '/settings/security',
                    render: () => (
                      <Security />
                    ),
                  }
                },
                {
                  message: formatMessage(messages.features),
                  to: '/settings/features',
                  route: {
                    path: '/settings/features',
                    component: Features,
                  }
                },
              ]} />
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default UserSettingsPage
